import axios from "axios";
import {
  fetchTeamMembersStart,
  getTeamMembersSuccess,
  getTeamMembersError,
} from "../slices/teamsSlice";
import { tmpHeader } from "../../utils/helper";

const API_URL = process.env.REACT_APP_API_URL;

export const fetchTeamMembers = () => async (dispatch) => {
  dispatch(fetchTeamMembersStart());
  try {
    const res = await axios.get(`${API_URL}/team-members`, {
      headers: tmpHeader(),
    });
    dispatch(getTeamMembersSuccess(res.data.data));
  } catch (err) {
    console.log("Get Team Members Error:", err.response);
    dispatch(getTeamMembersError(err.response.data.error));
  }
};

export const fetchTeamMemberById = (id) => async (dispatch) => {
  try {
    const res = await axios.get(`${API_URL}/team-members/${id}`, {
      headers: tmpHeader(),
    });
    dispatch(getTeamMembersSuccess([res.data.data]));
  } catch (err) {
    console.log("Get Blog Error:", err.response);
    dispatch(getTeamMembersError(err.response.data.error));
  }
};
